import { render, staticRenderFns } from "./editEmployerClient.vue?vue&type=template&id=a68e812a&scoped=true"
import script from "./editEmployerClient.vue?vue&type=script&lang=js"
export * from "./editEmployerClient.vue?vue&type=script&lang=js"
import style0 from "./editEmployerClient.vue?vue&type=style&index=0&id=a68e812a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68e812a",
  null
  
)

export default component.exports